import { render, staticRenderFns } from "./DeleteActionTypeModal.vue?vue&type=template&id=f566facc&scoped=true&class=fill-height&"
import script from "./DeleteActionTypeModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteActionTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteActionTypeModal.vue?vue&type=style&index=0&id=f566facc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f566facc",
  null
  
)

export default component.exports